import React from 'react'
import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { useCategoryStore, useGlobalCopyStore, useScreenSize } from '../../common'

import { SpendingData } from '../utils/SpendingData'
import SpendingDonut from './SpendingDonut'
import SpendingList from './SpendingList'

interface SpendingChartProps {
  data: SpendingData
  title: string
  onSelected: (id: string, isSubcategory?: boolean) => void
  onViewTransactions: (id: string) => void
  selectedId: string
}

const SpendingChart: React.FC<SpendingChartProps> = ({
  data,
  onSelected,
  onViewTransactions,
  selectedId,
  title,
}) => {
  const { isDesktop, isMobile } = useScreenSize()
  const { dateRangeTotalsLoading } = useCategoryStore()
  const { spending: spendingCopy } = useGlobalCopyStore()

  const handleDonutSelected = (id: string) => {
    onSelected(id)
    setTimeout(() => document.getElementById(`spending-list-category-${id}`)?.focus(), 0)
  }

  const loadingDonut = (
    <SpendingDonut
      data={{
        categoryData: [],
        donutData: [],
        totalAmount: 0,
      }}
      onSelected={() => {}}
      selectedId={''}
      size={isDesktop ? 400 : 300}
      totalLabel={'Loading ...'}
      variant="full"
    />
  )

  return (
    <Stack
      alignItems={isMobile ? 'center' : 'flex-start'}
      direction={isMobile ? 'column' : 'row'}
      gap={{ xs: 16, md: 64, xl: 100 }}
      justifyContent="center"
      pt={50}
      px={8}
    >
      {dateRangeTotalsLoading && loadingDonut}
      {/* Not using a ternary here because it doesn't show the animation */}
      {!dateRangeTotalsLoading && (
        <SpendingDonut
          data={data}
          onSelected={handleDonutSelected}
          onViewTransactions={onViewTransactions}
          selectedId={selectedId}
          size={isDesktop ? 400 : 300}
          totalLabel={spendingCopy.total_amount}
          variant="full"
        />
      )}

      <SpendingList data={data} onSelected={onSelected} selectedId={selectedId} title={title} />
    </Stack>
  )
}

export default observer(SpendingChart)
